const config = {
  ssoUrl: 'https://api.bigroad.com/partner-sign-in/freight', // UPDATE WHEN AVAILABLE
  clarityId: '6xhswni1vu', // UPDATE WHEN AVAILABLE
};

export default config;
